<?php

namespace Model ;

class Configuration {

    public static $config ;

    public static function variable($var) {
        if (UNITER_BUILD_LEVEL == 'production') {
            $file_ext = 'php' ;
        } else {
            $file_ext = 'fephp' ;
        }
        require (REQUIRE_PREFIX.'/core/default.'.$file_ext) ;
        $config = \Model\Configuration::$config ;
        if (isset($config['api_base_url']) && $config['api_base_url'] !== '') {
            $config['ISOPHP_API_SERVER_URL'] = $config['api_base_url'] ;
        } else {
            $config['ISOPHP_API_SERVER_URL'] = 'https://' . $config['server_subdomain'] . '.' . $config['domain'] ;
        }

        if (isset($config['backendenv']) && $config['backendenv'] !== '') {
            $config['env_level'] = $config['backendenv'] ;
        } else {
            $config['env_level'] = 'prod' ;
        }
        if (isset($config[$var])) {
            return $config[$var];
        }
        return null ;
    }

}



// WEBPACK FOOTER //
// core/app_vars.php